<template>
  <section class="is-flex">
    <FormMultiSelect
      v-model="filter.operator"
      :config="rangeQueryOperatorConfig"
      :show-float-label="false"
      :rules="{ required: true }"
      :data-e2e="TableCypressAttribute.filter.inputs.OPERATORS"
    />
    <div class="is-flex m-l-10" :class="{ 'is-split': canBeInRange }">
      <FormInput
        v-model="filter.value"
        type="number"
        :rules="{ required: true }"
        :data-e2e="TableCypressAttribute.filter.inputs.VALUE_FORM_ELEMENT"
      />
      <div v-if="canBeInRange" class="m-l-10">
        <FormInput
          v-model="filter.secondValue"
          type="number"
          :rules="{ required: true }"
          :data-e2e="TableCypressAttribute.filter.inputs.SECOND_VALUE_FORM_ELEMENT"
        />
      </div>
    </div>
  </section>
</template>

<script>
import FormMultiSelect from '/@/modules/core/form/components/FormMultiSelect.vue';
import { FormSelectConfig } from '/@/modules/core/form/models/FormSelectConfig';
import { TableFilter } from '/@/modules/core/table/models/TableFilter';
import { UrlQueryOperator } from '/@/modules/core/app/constants/UrlQueryOperator';
import FormInput from '/@/modules/core/form/components/FormInput.vue';
import { TableCypressAttribute } from '/@/modules/core/table/constants/TableCypressAttribute';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'RangeTableFilter',
  components: { FormInput, FormMultiSelect },
  props: {
    tableFilter: {
      type: TableFilter,
      required: true
    }
  },
  static: {
    TableCypressAttribute
  },
  data() {
    return {
      filter: this.tableFilter,
      value: null,
      showEnumValueSelectionSelect: false,
      rangeQueryOperatorConfig: new FormSelectConfig({
        options: Object.values(UrlQueryOperator)
      })
    };
  },
  computed: {
    canBeInRange() {
      return (
        this.tableFilter.operator === UrlQueryOperator.BETWEEN.key ||
        this.tableFilter.operator === UrlQueryOperator.NOT_BETWEEN.key ||
        this.tableFilter.operator === UrlQueryOperator.IN.key ||
        this.tableFilter.operator === UrlQueryOperator.NOT_IN.key
      );
    }
  }
};
</script>
